import { getHourOffset } from 'modules/Date';
import { getApiUrl } from 'modules/Url';

type CreateNewEpisodeParams = {
  webStationId: string;
  title?: string;
  description?: string;
};

type CreateNewEpisodeResponse = {
  webEpisodeId: string;
};

export async function createNewEpisode({
  webStationId,
  title,
  description,
}: CreateNewEpisodeParams): Promise<CreateNewEpisodeResponse> {
  try {
    const response = await fetch(
      getApiUrl({
        path: `stations/webStationId:${webStationId}/episodes`,
        queryParameters: {
          returnWebIds: true,
          useLatestAuth: true,
        },
      }),
      {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
        body: JSON.stringify({
          title,
          description,
          hourOffset: getHourOffset(),
        }),
      }
    );

    if (response.ok) {
      return response.json();
    }
    throw new Error('Error creating new episode');
  } catch (e) {
    throw new Error(e.message);
  }
}
